/* 11.10 (Pat, Clarity day 1): a customer typed the cake fields three times - opened an add-on ("Wybierz" -> candle product
   page), came back to the cake and everything was empty again. This keeps what was chosen on a product page for this tab
   (sessionStorage, 2 h) and puts it back on the next visit of the same product:
   - shape + size (the cake configurator's buttons, else the native option radios) - not when the URL already names a variant,
   - the add-ons ticked (cross-product checkboxes, by variant id; the inscription add-on follows its text field),
   - the inscription, the letter text and the candle digits.
   Nothing is restored once this product is in the cart (the choice was used) - the saved copy is dropped then.
   Same idea as the cart draft (assets/batida-cart-v2.js, J-01). No personal data: only what is typed on the cake. */
(function () {
  if (window.__batidaPdpKeep) return; window.__batidaPdpKeep = true;
  var m = location.pathname.match(/\/products\/([^\/?#]+)/); if (!m) return;
  var KEY = 'batida-pdp-keep:' + decodeURIComponent(m[1]), TTL = 2 * 3600 * 1000, restoring = false, touched = false, timer = null;
  // the option radios are tied to the add-to-cart form by its form="" attribute, not inside it
  var TEXTS = { napis: '#batida-napis-text', msg: 'textarea[name="properties[_Message-Wiadomosc]"]', candles: '.cross-product__input-text--candles' };
  function q(s) { return document.querySelector(s); }
  function load() { try { var d = JSON.parse(sessionStorage.getItem(KEY) || 'null'); return d && Date.now() - d.t < TTL ? d : null; } catch (e) { return null; } }
  function drop() { try { sessionStorage.removeItem(KEY); } catch (e) {} }
  function productId() {
    try { var p = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product; if (p && p.id) return String(p.id); } catch (e) {}
    var i = q('form[action*="/cart/add"] input[name="product-id"]'); return i ? String(i.value) : '';
  }
  function snapshot() {
    var d = { t: Date.now(), opts: {}, cb: [], tx: {}, any: false };
    document.querySelectorAll('#MainContent input[type="radio"][name^="options["]:checked').forEach(function (r) { d.opts[r.name] = r.value; });
    if (Object.keys(d.opts).length) d.any = true;   // saved only after the customer's own action, so a chosen size counts too
    document.querySelectorAll('.cross-product__checkbox:checked').forEach(function (c) {
      var cp = c.closest('.cross-product'); if (cp && cp.getAttribute('data-canonical-handle') === 'napis-na-torcie') return;
      var lm = cp && (cp.className || '').match(/cross-product--(\S+)/);
      if (c.getAttribute('data-variant-id')) { d.cb.push({ v: c.getAttribute('data-variant-id'), h: [cp && cp.getAttribute('data-canonical-handle'), lm && lm[1]].filter(Boolean) }); d.any = true; }
    });
    Object.keys(TEXTS).forEach(function (k) { var el = q(TEXTS[k]); if (el && String(el.value).trim()) { d.tx[k] = el.value; d.any = true; } });
    return d;
  }
  function save() {
    if (restoring) return;
    var d = snapshot();
    try { if (d.any) sessionStorage.setItem(KEY, JSON.stringify(d)); else drop(); } catch (e) {}
  }
  // only the customer's own actions count (e.isTrusted): the configurator pre-selects the round shape by script on every load,
  // which must neither block the restore nor overwrite the saved copy with the defaults
  function soon(e) { if (!e.isTrusted || restoring) return; touched = true; clearTimeout(timer); timer = setTimeout(save, 300); }
  function isOurs(t) {
    return t && t.matches && (t.matches('.cross-product__checkbox, input[type="radio"][name^="options["]') || Object.keys(TEXTS).some(function (k) { return t.matches(TEXTS[k]); }));
  }
  document.addEventListener('input', function (e) { if (isOurs(e.target)) soon(e); }, true);
  document.addEventListener('change', function (e) { if (isOurs(e.target)) soon(e); }, true);
  // the add-on rows and configurator buttons are clicked by the customer; the checkbox/radio change they cause is scripted
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-batida-cake-shape], [data-batida-cake-serving], .batida-perso-toggle, .batida-addon-row, .cross-product')) soon(e); }, true);
  window.addEventListener('pagehide', function () { if (touched && !restoring) save(); });

  function setText(el, v) {
    if (!el || String(el.value).trim()) return;
    el.value = v;
    try { el.dispatchEvent(new Event('input', { bubbles: true })); el.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
  }
  function restore(d) {
    if (touched) return;   // the customer already started choosing on this visit: theirs wins, nothing is put back
    restoring = true;
    try {
      if (!/[?&]variant=/.test(location.search)) {
        Object.keys(d.opts || {}).forEach(function (name) {   // DOM order: shape before size (a shape click may pick another size)
          var val = d.opts[name], sel = '#MainContent input[type="radio"][name="' + name.replace(/"/g, '\\"') + '"]';
          var cur = q(sel + ':checked'); if (cur && cur.value === val) return;
          // the cake configurator's button when there is one (keeps its look, filters and diameters in step), else the native radio
          var attr = /kszta|shape|форма|forme|form\]/i.test(name) ? 'data-batida-cake-shape' : 'data-batida-cake-serving', btn = null;
          document.querySelectorAll('.batida-cake-configurator [' + attr + ']').forEach(function (b) { if (b.getAttribute(attr) === val) btn = b; });
          if (btn) { if (!btn.disabled) btn.click(); return; }
          document.querySelectorAll(sel).forEach(function (r) { if (r.value === val && !r.checked && !r.disabled) r.click(); });
        });
      }
      // an add-on is switched on through its visible switch (.batida-perso-row[data-handle] .batida-perso-toggle), which ticks the
      // hidden cross-product checkbox and keeps the row's look in step; the checkbox itself only when there is no switch
      (d.cb || []).forEach(function (a) {
        var c = q('.cross-product__checkbox[data-variant-id="' + a.v + '"]'); if (!c || c.checked || c.disabled) return;
        var tg = null; (a.h || []).forEach(function (h) { if (!tg) { var row = q('.batida-perso-row[data-handle="' + h + '"]'); tg = row && row.querySelector('.batida-perso-toggle'); } });
        if (tg && tg.offsetParent !== null) { if (tg.getAttribute('aria-pressed') !== 'true') tg.click(); } else c.click();
      });
    } catch (e) {}
    // the add-on boxes open their fields on the click; fill the texts a moment later
    setTimeout(function () {
      try { Object.keys(d.tx || {}).forEach(function (k) { setText(q(TEXTS[k]), d.tx[k]); }); } catch (e) {}
      restoring = false; save();
    }, 350);
  }
  function start() {
    var d = load(); if (!d) { drop(); return; }
    var pid = productId();
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if (pid && (c.items || []).some(function (i) { return String(i.product_id) === pid; })) { drop(); return; }   // already in the cart = the choice was used
      var tries = 0;
      (function wait() {   // the configurator and the add-on boxes are built by other deferred scripts
        if ((q('.batida-cake-configurator') || !document.body.classList.contains('batida-v71-active')) && (q('.cross-product__checkbox') || tries > 3) || tries > 8) { restore(d); return; }
        tries++; setTimeout(wait, 250);
      })();
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 150); }); else setTimeout(start, 150);
})();
